export { default } from "./AnimatedText";